import {
  GroupContextSchemaData,
  NotificationContextSchemaData,
  PostContextSchemaData,
  UserContextSchemaData,
} from '../schema'
import { trackEvent } from './helper'

type UserEventParams = {
  user: UserContextSchemaData
  post?: PostContextSchemaData
  group?: GroupContextSchemaData
  notification?: NotificationContextSchemaData
}

export const report_user = (props: UserEventParams) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'report',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })

export const block_user = (props: UserEventParams) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'block',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })

export const unblock_user = (props: UserEventParams) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'unblock',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })

export const follow = (props: UserEventParams) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'follow',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })

export const unfollow = (props: UserEventParams) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'unfollow',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })

export const delete_footprint = (props: {
  user?: UserContextSchemaData
  notification: NotificationContextSchemaData
}) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'delete_footprint',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })

export const open_footprint = () =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'open_footprint',
      format: 'jsonschema',
      version: '1-0-0',
    },
  })
